import { useCallback } from "react";
import { useModal } from "@racoon/ui";
import { ConnectProto } from "@racoon/api";
import { CreateOrderDialogBody } from "./create-order-body.dialog";
import { JobCardHeading } from "../components/job-card-heading";
import { orderFormBodyClass, orderFormModalShell } from "./order-form-styles";

/**
 * Opens a job's card — the create-order dialog in edit mode — optionally with the
 * list of jobs the card steps through.
 */
export function useJobCard() {
  const { openModal, closeModal } = useModal();

  const openJob = useCallback(
    (job: ConnectProto.Job, jobs: ConnectProto.Job[] = []) => {
      const index = jobs.findIndex((item) => item.id === job.id);
      const idRef = { current: "" };
      const renderBody = (item: ConnectProto.Job) => (
        <CreateOrderDialogBody editOrder={item} onClose={() => closeModal(idRef.current)} />
      );

      idRef.current = openModal({
        ...orderFormModalShell,
        ...(index >= 0 && jobs.length > 1
          ? {
              navigation: {
                items: jobs,
                initialIndex: index,
                getItemId: (item: ConnectProto.Job) => String(item.id),
                renderTitle: (item: ConnectProto.Job) => <JobCardHeading job={item} />,
                renderBody,
                // A form: the arrow keys belong to its fields
                keyboardNavigation: false,
              },
            }
          : {
              title: <JobCardHeading job={job} />,
              body: renderBody(job),
              bodyClassName: orderFormBodyClass,
            }),
      });
    },
    [openModal, closeModal],
  );

  return { openJob };
}
